<!--历史记录-->
<template>
  <el-dialog custom-class="max-dialog1256" title="订单差价记录" :visible.sync="dialogFormVisible" center
             :append-to-body="true"
             :close-on-click-modal="false"
  >
    <el-col :span="24">
      <div>
        <el-table v-show="type==1"
          :data="tableDataOrder"
          size="mini" :height="tableHeight(94)"
          stripe show-summary
          border :summary-method="getSummaries"
          style="width: 100%;">
          <el-table-column
            width="60"
            label="序号" fixed
            align="center">
            <template slot-scope="scope">
              {{1+scope.$index}}
            </template>
          </el-table-column>
          <el-table-column
            prop="adddate"
            label="添加时间"
            align="center"
            header-align="center"
            width="90">
            <template slot-scope="scope">
              {{(scope.row.adddate||"").substr(0,10)}}
            </template>
          </el-table-column>
          <el-table-column
            prop="uname"
            label="添加人员"
            align="center"
            header-align="center"
            width="70">
          </el-table-column>
          <el-table-column
            prop="ordernum"
            label="订单编号"
            align="center"
            header-align="center"
            width="120"
          >
            <template slot-scope="scope">
              <span >{{scope.row.ordernum}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="seedcode"
            label="产品编号"
            align="center"
            header-align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="seedname"
            label="产品名称"
            align="left"
            header-align="center"
          >
          </el-table-column>
          <el-table-column
            prop="totalnumber"
            label="数量"
            align="center"
            header-align="center"
            width="60"
          ></el-table-column>
          <el-table-column
            prop="saleprice"
            label="原单价"
            align="right"
            header-align="center"
            width="80">
            <template slot-scope="scope">
              {{scope.row.saleprice|numeric(3)}}
            </template>
          </el-table-column>
          <el-table-column
            prop="totalmoneytax"
            label="原金额"
            align="right"
            header-align="center"
            width="90">
            <template slot-scope="scope">
              {{scope.row.totalmoneytax|numeric(2)}}
            </template>
          </el-table-column>
          <el-table-column
            prop="newsaleprice"
            label="新单价"
            align="right"
            header-align="center"
            width="80">
            <template slot-scope="scope">
              {{scope.row.newsaleprice|numeric(3)}}
            </template>
          </el-table-column>
          <el-table-column
            prop="newtotalmoneytax"
            label="新金额"
            align="right"
            header-align="center"
            width="90">
            <template slot-scope="scope">
              {{scope.row.newtotalmoneytax|numeric(2)}}
            </template>
          </el-table-column>
          <el-table-column
            prop="diff"
            label="差额"
            align="right"
            header-align="center"
            width="90">
            <template slot-scope="scope">
              {{scope.row.diff|numeric(2)}}
            </template>
          </el-table-column>
        </el-table>

        <el-table v-show="type==2"
          :data="tableDataCategory"
          size="mini" :height="tableHeight(94)"
          stripe show-summary
          border :summary-method="getSummariesCategory"
          style="width: 100%;">
          <el-table-column
            width="60"
            label="序号" fixed
            align="center">
            <template slot-scope="scope">
              {{1+scope.$index}}
            </template>
          </el-table-column>
          <el-table-column
            prop="adddate"
            label="添加时间"
            align="center"
            header-align="center"
            width="100">
            <template slot-scope="scope">
              {{(scope.row.adddate||"").substr(0,10)}}
            </template>
          </el-table-column>
          <el-table-column
            prop="uname"
            label="添加人员"
            align="center"
            header-align="center"
            width="70">
          </el-table-column>
          <el-table-column
            prop="categorycode"
            label="品牌编号"
            align="center"
            header-align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="categoryname"
            label="品牌名称"
            align="left"
            header-align="center"
          >
          </el-table-column>
          <el-table-column
            prop="totalnumber"
            label="数量"
            align="center"
            header-align="center"
            width="60"
          ></el-table-column>
          <el-table-column
            prop="totalmoneytax"
            label="原金额"
            align="right"
            header-align="center"
            width="90">
            <template slot-scope="scope">
              {{scope.row.totalmoneytax|numeric(2)}}
            </template>
          </el-table-column>
          <el-table-column
            prop="newtotalmoneytax"
            label="新金额"
            align="right"
            header-align="center"
            width="90">
            <template slot-scope="scope">
              {{scope.row.newtotalmoneytax|numeric(2)}}
            </template>
          </el-table-column>
          <el-table-column
            prop="diff"
            label="差额"
            align="right"
            header-align="center"
            width="90">
            <template slot-scope="scope">
              {{scope.row.diff|numeric(2)}}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-col>
    <div slot="footer" class="dialog-footer no-print">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="exportExcel">导出</el-button>
      <span @click="brandSummary" style="cursor:pointer;margin-left: 20px;" >{{type==1?'切换品牌查询':'切换订单查询'}}</span>
    </div>
  </el-dialog>
</template>

<script>

  import {getOrderList,getBrandList} from '@/api/order/salecontractdiffrecord'
  export default {
    name: 'DetailList',
    data() {
      return {
        msg: 'Welcome to Your Vue.js App',
        dialogFormVisible: false,
        tableDataOrder: [],
        tableDataCategory: [],
        type:1,//1表示根据订单查询，2表示查询品牌汇总
        erpserial: '',//合同编号
        sumsOrder:[],
        sumsCategory:[]
      }
    },
    methods: {
      //切换
      brandSummary(){
        if(this.type==1){
          this.type=2
          if(this.tableDataCategory.length==0) {
            this.bindGridCategory()
          }
        }else{
          this.type=1
          if(this.tableDataOrder.length==0) {
            this.bindGridOrder()
          }
        }
      },
      show(erpserial,customerserial) {
        this.initform()
        this.dialogFormVisible = true
        this.erpserial = erpserial
        this.ordercustomerserial=customerserial
        this.bindGridOrder()
      },
      //导出excel
      exportExcel() {
        let header1 =this.type==1? ["添加时间", "添加人员", "订单编号", "产品编号", "产品名称", "数量", "原单价", "原金额", "新单价", "新金额", "差额"]: ["添加时间", "添加人员" , "品牌编码", "品牌名称",  "原金额",  "新金额", "差额"]
        let column1 =this.type==1 ? ["adddate", "uname", "ordernum", "seedcode", "seedname", "totalnumber", "saleprice", "totalmoneytax", "newsaleprice", "newtotalmoneytax", "diff"]:["adddate", "uname",  "categorycode", "categoryname","totalmoneytax", "newtotalmoneytax", "diff"]   //与header一一对应，注意顺序
        let title = "订单差价记录"
        let data = [].concat(this.type==1?this.tableDataOrder:this.tableDataCategory)
        if(this.type==1){
          data.push({adddate: "合计", totalmoneytax: this.sumsOrder[8], newtotalmoneytax: this.sumsOrder[10], diff: this.sumsOrder[11]})
        }else{
          data.push({adddate: "合计", totalmoneytax: this.sumsCategory[6], newtotalmoneytax: this.sumsCategory[7], diff: this.sumsCategory[8]})
        }
        this.$exportExcel(header1, column1, data, title)
      },
      //根据订单查询
      bindGridOrder() {
        getOrderList({
          erpserial: this.erpserial,
          ordercustomerserial:this.ordercustomerserial,
          sort: 'ordernum',//ordernum排序
        }).then(response => {
          this.tableDataOrder = response.data.obj
        }).catch((error) => {
          console.log(error)
        })
      },
      //根据品牌分组查询
      bindGridCategory() {
        getBrandList({
          erpserial: this.erpserial,
          ordercustomerserial:this.ordercustomerserial,
          sort: 'ordernum',//ordernum排序
        }).then(response => {
          this.tableDataCategory = response.data.obj
        }).catch((error) => {
          console.log(error)
        })
      },
      getSummaries(param) {
        const {columns, data} = param;
        let sums = [];
        columns.forEach((column, index) => {
          if (index === 1) {
            sums[index] = '合计';
            return;
          } else if (column.property != 'totalmoneytax' && column.property != 'newtotalmoneytax' && column.property != 'diff') {
            sums[index] = ""
            return
          }
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
          } else {
            sums[index] = '';
          }
        });
        sums[11] = this.$numeric(sums[11], 2)
        sums[8] = this.$numeric(sums[8], 2)
        sums[10] = this.$numeric(sums[10], 2)
        this.sumsOrder=sums
        return sums;
      },

      getSummariesCategory(param) {
        const {columns, data} = param;
        let sums = [];
        columns.forEach((column, index) => {
          if (index === 1) {
            sums[index] = '合计';
            return;
          } else if (column.property != 'totalmoneytax' && column.property != 'newtotalmoneytax' && column.property != 'diff') {
            sums[index] = ""
            return
          }
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
          } else {
            sums[index] = '';
          }
        });
        sums[6] = this.$numeric(sums[6], 2)
        sums[7] = this.$numeric(sums[7], 2)
        sums[8] = this.$numeric(sums[8], 2)
        this.sumsCategory=sums
        return sums;
      },

      initform() {
        this.tableDataOrder = []
        this.tableDataCategory=[]
        this.erpserial = ""
        this.ordercustomerserial=""
        this.type=1
        this.sumsOrder=[]
        this.sumsCategory=[]
      },

    },
    mounted() {

    },
    components: {
    }

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


  /*.el-table td, .el-table div, .el-table .cell {*/
  /*line-height: 23px;*/
  /*padding: 0px;*/
  /*color: red;*/
  /*}*/

</style>



// WEBPACK FOOTER //
// src/components/testorder/salecontract/DiffRecordList.vue